import { queryClient } from '@/lib/react-query';

export const logout = () => {
  sessionStorage.clear();
  localStorage.removeItem(`token`);
  localStorage.removeItem(`storage-type`);
  localStorage.removeItem(`auth-user`);
  localStorage.removeItem(`company`);
  localStorage.removeItem(`layout-view`);
  queryClient.invalidateQueries();
};
